// src/constants/Typography.js
import InterRegular from "./fonts/Inter_18pt-Regular.ttf";
import InterMedium from "./fonts/Inter_18pt-Medium.ttf";
import InterBold from "./fonts/Inter_18pt-Bold.ttf";

export const Typography = {
  FONT_FAMILY: `
    "Inter", 
    -apple-system, 
    BlinkMacSystemFont, 
    "Segoe UI", 
    Roboto, 
    "Helvetica Neue", 
    Arial, 
    sans-serif
  `.trim(), // Fallback fonts
  FONT_SIZE_BASE: "16px",
  FONT_WEIGHT_REGULAR: "400",
  FONT_WEIGHT_MEDIUM: "500",
  FONT_WEIGHT_BOLD: "700",
};

// Export font files for CSS import (optional)
export { InterRegular, InterMedium, InterBold };
